// Definimos la URL base según la variable de entorno, con fallback a localhost
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchHospedajes = async ({ limit, offset, query }) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ limit, offset, query }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener los hospedajes');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener los hospedajes:', error);
    throw error;
  }
};

export const createHospedaje = async (hospedajeData) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(hospedajeData),
    });

    if (!response.ok) {
      throw new Error('Error al crear el hospedaje');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al crear el hospedaje:', error);
    throw error;
  }
};

export const updateHospedaje = async (id, hospedajeData) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, data: hospedajeData }),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar el hospedaje');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar el hospedaje:', error);
    throw error;
  }
};

export const deleteHospedaje = async (id) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/delete/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Error al eliminar el hospedaje');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al eliminar el hospedaje:', error);
    throw error;
  }
};

export const exportHospedajes = async ({ query = {}, limit = 10000, page = 1 }) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/export`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    });

    if (!response.ok) {
      throw new Error('Error al exportar los hospedajes');
    }

    const result = await response.json();
    
    // El backend devuelve JSON con estructura { data: [], totalRecords: number }
    // Retornamos los datos para que ExportExcelButton los procese
    return result.data || [];
  } catch (error) {
    console.error('Error al exportar los hospedajes:', error);
    throw error;
  }
};

export const getCoordinadores = async () => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/coordinadores`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });    
    if (!response.ok) {
      throw new Error('Error al obtener los coordinadores');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener los coordinadores:', error);
    throw error;
  }
};

export const getEdificios = async () => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/edificios`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error('Error al obtener los edificios');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener los edificios:', error);
    throw error;
  }
};

export const updateHospedajeCamas = async (id, camas) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/update-camas/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ camas }),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar las camas del hospedaje');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar las camas del hospedaje:', error);
    throw error;
  }
};

export const updateHospedajeBanos = async (id, banos) => {
  try {
    const response = await fetch(`${API_URL}/hospedajes/update-banos/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ banos }),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar los baños del hospedaje');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar los baños del hospedaje:', error);
    throw error;
  }
};
